<template>
    <modal
      :show-modal="showModal"
      @close-modal="closeModal"
      width="40"
    >
       <div>
        <h2 class=" text-primary-yellow text-center font-semibold text-xl">Awesome!</h2>
        <p class="py-2 text-center">We have received your feedback.</p>
           <p class="flex justify-center py-4">
            <img src="@/assets/images/icons/message_thankyou.svg"/>
           </p>
        <p class="flex justify-around z-10">
            <img src="@/assets/images/icons/leaf_icon.svg"/>
           <span>
            <button class="py-2 px-3 rounded bg-primary-yellow">Close</button>
           </span>
            <img src="@/assets/images/icons/leaf_icon.svg" class="rotate-x"/>
        </p>

       </div>
    </modal>
  </template>
  
  <script>
  export default {
    props: ["showModal"],
    data(){
      return {
        reference: ""
      }
    },
    methods: {
      closeModal() {
        this.$emit("close-modal");
      },
    },
  };
  </script>
  
  <style> 
  .plain-box{
    width: 100%;
    height: 400px;
    position: relative;
  }
  .click-box{
    width: 200px;
    left: calc(100% - 100px);
    top: calc(100% - 100px);
    text-align: center;
    height: 30px;
  }
  .entity-name {
    background: #dae8f6;
    padding: 0.5em;
    text-align: center;
  }
  .rotate-x{
    transform: rotateY(180deg);
  }
  </style>